export default __webpack_public_path__ + "static/l5-about-mid-d71b9fef1c9a6be7bc75ae943cb0c841.jpg";